import React, { useEffect, useState } from "react";
import "./UnitHistory.css";
import Sidebar from "../../../components/app-sidebar/Sidebar";
import ErrorHandler from "../../../components/error/ErrorHandler";
import Top from "../../../components/app-top/Top";
import arrowLeftIcon from "../../../images/arrow-left-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";
import { Pagination } from "../../../components/pagination/Pagination";
import UnitHistoryTable from "./unit-history-table/UnitHistoryTable";
import { IUnitHistory } from "../../../Types";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getCompanyUnitHistory } from "../../../redux/actions/companyActions";

function UnitHistory() {
  // Functions, States and Variables
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const walletHistory: IUnitHistory[] | [] = useAppSelector(
    (state) => state.companies.walletHistory
  );
  //   States
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [companyUnitBalance, setCompanyUnitBalance] = useState("");
  const [currentWalletHistoryPosts, setCurrentWalletHistoryPosts] = useState<
    IUnitHistory[] | null
  >(null);
  const [errorHandlerObj, setErrorHandlerObj] = useState({
    hasError: false,
    message: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const indexOfLastPost = currentPage * rowsPerPage;
  const indexOfFirstPost = indexOfLastPost - rowsPerPage;
  // Functions
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  //   UseEffects
  useEffect(() => {
    if (location.state) {
      const { subsidiaryId, subsidiaryName, unit }: any = location.state;

      // console.log('location',location);
      //   Update Subsidiary name state
      setSelectedCompanyName(subsidiaryName);
      setCompanyUnitBalance(unit);
      //   Call the API to fetch wallet history for subsidiary
      dispatch(
        getCompanyUnitHistory(subsidiaryId, setIsLoading, setErrorHandlerObj)
      );
    } else {
      navigate(-1);
    }
  }, [location]);

  useEffect(() => {
    if (walletHistory) {
      const currentRows = walletHistory?.slice(
        indexOfFirstPost,
        indexOfLastPost
      );
      setCurrentWalletHistoryPosts(currentRows);
    }
  }, [walletHistory, currentPage]);

  return (
    <div className={`certificates-container`}>
      <Top pageSummaryMessage={""} />

      <div className="certificates-container--inner">
        <Sidebar activeName={"Companies"} />

        {/* Error Handler Obj Wrapper */}
        <ErrorHandler
          errorHandlerObj={errorHandlerObj}
          className="app-error-success-message-wrapper"
        />

        <div className="selected-company-name-wrapper">
          <div className="certificates--back-button-wrapper">
            <button onClick={() => navigate(-1)}>
              {/* <button onClick={() => navigate("/companies")}> */}
              <img src={arrowLeftIcon} alt="" />
            </button>
          </div>
          {selectedCompanyName}
        </div>

        <section className="certificates-container-main-section">
          {/* Wallet Balance Wrapper */}
          <div className="history--wallet-balance-wrapper">
            <div className="title-wrapper">Unit Balance:</div>
            <div className="value-wrapper">
              {" "}
              {companyUnitBalance?.toLocaleString()}
            </div>
          </div>
          {/* Wallet History Table Container */}
          <UnitHistoryTable
            currentPosts={currentWalletHistoryPosts}
            isLoading={isLoading}
            companyUnitBalance={companyUnitBalance}
          />
          {!isLoading &&
            // walletHistory &&
            !isEmpty(currentWalletHistoryPosts) && (
              <>
                <Pagination
                  paginate={paginate}
                  rowsPerPage={rowsPerPage}
                  totalPosts={walletHistory.length}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </>
            )}
        </section>
      </div>
    </div>
  );
}

export default UnitHistory;
